import PropTypes from 'prop-types';
import React from 'react';

class BulletList extends React.Component {
  static propTypes = {
    text: PropTypes.string
  };

  render() {
    let bullets;

    let _text = this.props.text
      .replace(/\|-/g, '~~~')
      .split('|')
      .map(x => x.replace(/~~~/g, '|-'));
    
    bullets = _text.map((par, i) => {
      if (!par.includes('|-')) {
        return <p key={i}>{par}</p>;
      }
      const parts = par.split('|-');

      return <div key={i}>
        <ul>
          {parts.map((z, j) => <li key={`list-items.${j}`}>{z}</li>)}
        </ul>
      </div>;
    });

    return bullets;
  }
}
  
export default BulletList;